import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalRedirectComponent
} from '@azure/msal-angular';
import { msalConfig, msalGuardConfig, msalInterceptorConfig, msalInstance } from './msal-config';

/**
 * MSAL Angular Module
 * This module configures and provides the MSAL services for the application
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MsalModule.forRoot(
      msalInstance,
      msalGuardConfig,
      msalInterceptorConfig
    )
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  exports: [
    MsalModule
  ]
})
export class MsalAuthModule { }
